import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import { requestContent } from "./actions"

import Tutorial from "./components/Tutorial"
import { IOldUIContext, IOldUIInit } from "../../global"

function init(store: AppStore, oldUIContext: IOldUIContext): IOldUIInit {
    const start = (): void => {
        const element = document.getElementById("newui-tutorial")
        store.dispatch(requestContent())

        if (element) {
            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <OldUIContext.Consumer>
                            {(): JSX.Element => <Tutorial />}
                        </OldUIContext.Consumer>
                    </OldUIContext.Provider>
                </Provider>,
            )
        }
    }

    return {
        start,
    }
}

export default init
